import React, { FC } from 'react';
import AreaChartLoader from 'components/Loaders/LargeAreaChart';
import IndicatorLoader from 'components/Loaders/Indicator';
import PieChartLoader from 'components/Loaders/PieChart';
import RatingsCardLoader from 'components/Loaders/RatingsCardSummary';
import {
  Container,
  Indicators,
  TwoColumns,
  Section,
  Title,
  SectionTitle,
  Indicator,
  RatingsCard,
  Top5Item,
  RankingItem,
  Name,
  Number,
  CircledNumber,
  ChartWrapper,
  PieChart,
  AreaChart,
  Fragment,
} from './styles';
import useConnect from './connect';
import { Props } from './types';

const Summary: FC<Props> = ({ brandId }) => {
  const { summary, isLoading } = useConnect({ brandId });

  return (
    <Container>
      <Title>Previous Week Performance</Title>
      <Indicators>
        {!summary || isLoading ? (
          <>
            <IndicatorLoader />
            <IndicatorLoader />
            <IndicatorLoader />
            <IndicatorLoader />
          </>
        ) : (
          <>
            <Indicator
              title="Sales"
              amount={summary.totalSales.value}
              trend={summary.totalSales.change < 0 ? 'DOWN' : 'UP'}
              percentage={summary.totalSales.change}
            />
            <Indicator
              title="Orders"
              amount={`${summary.orders.value}`}
              trend={summary.orders.change < 0 ? 'DOWN' : 'UP'}
              percentage={summary.orders.change}
            />
            <Indicator
              title="Average orders / Day"
              amount={`${summary.ordersPerDay.value}`}
              trend={summary.ordersPerDay.change < 0 ? 'DOWN' : 'UP'}
              percentage={summary.ordersPerDay.change}
            />
            <Indicator
              title="Average orders value"
              amount={`${summary.aov.value}`}
              trend={summary.aov.change < 0 ? 'DOWN' : 'UP'}
              percentage={summary.aov.change}
            />
          </>
        )}
      </Indicators>

      <TwoColumns>
        <Fragment>
          <SectionTitle>Revenue</SectionTitle>
          {!summary || isLoading ? (
            <AreaChartLoader />
          ) : (
            <AreaChart
              data={summary.revenue}
              variant="green"
              hideAxisX
              isMoney
              yAxisTooltipName="Revenue"
            />
          )}
        </Fragment>

        <Fragment>
          <Section>
            <SectionTitle>Top sold items</SectionTitle>
            {!summary || isLoading ? (
              <RatingsCardLoader />
            ) : (
              <RatingsCard>
                {summary.topItems.map((item, index) => (
                  <Top5Item key={item.name}>
                    <CircledNumber>{index + 1}</CircledNumber>
                    <Name>{item.name}</Name>
                    <Number>{item.count}</Number>
                  </Top5Item>
                ))}
              </RatingsCard>
            )}
          </Section>

          <Section>
            <SectionTitle>Ratings</SectionTitle>
            {!summary || isLoading ? (
              <RatingsCardLoader />
            ) : (
              <RatingsCard>
                {summary.ratings.map((rating) => (
                  <RankingItem key={rating.name}>
                    <Name>{rating.name}</Name>
                    <Number>{rating.value}</Number>
                  </RankingItem>
                ))}
              </RatingsCard>
            )}
          </Section>

          <Section>
            <SectionTitle>Sales</SectionTitle>
            {!summary || isLoading ? (
              <PieChartLoader />
            ) : (
              <ChartWrapper>
                <PieChart data={summary.sales} />
              </ChartWrapper>
            )}
          </Section>
        </Fragment>
      </TwoColumns>
    </Container>
  );
};

export default Summary;
